'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDeleteOutline = function TiDeleteOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z m0 26.7c-6.4 0-11.7-5.3-11.7-11.7s5.3-11.7 11.7-11.7 11.7 5.3 11.7 11.7-5.3 11.7-11.7 11.7z m1.2-11.7l4.4-4.4c0.3-0.3 0.3-0.9 0-1.2-0.3-0.3-0.9-0.3-1.2 0l-4.4 4.4-4.4-4.4c-0.3-0.3-0.9-0.3-1.2 0-0.3 0.3-0.3 0.9 0 1.2l4.4 4.4-4.4 4.4c-0.3 0.3-0.3 0.9 0 1.2 0.2 0.2 0.4 0.2 0.6 0.2s0.4 0 0.6-0.2l4.4-4.4 4.4 4.4c0.2 0.2 0.4 0.2 0.6 0.2s0.4 0 0.6-0.2c0.3-0.3 0.3-0.9 0-1.2l-4.4-4.4z' })
        )
    );
};

exports.default = TiDeleteOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/delete-outline.js
// module id = 1859
// module chunks = 0